'use client';

// Updated import path
import { useTranslations } from 'next-intl';
import React from 'react';

import { LocationListItem } from '@ui/components/features/locationSearch/locationListItem';

import { RecentLocation } from './types';

interface RecentLocationsListProps {
  locations: RecentLocation[];
  onLocationSelect: (location: RecentLocation) => void;
  hideHeader?: boolean;
  headerText?: string;
}

export const RecentLocationsList: React.FC<RecentLocationsListProps> = ({
  locations,
  onLocationSelect,
  hideHeader = false,
  headerText
}) => {
  const t = useTranslations();

  if (locations.length === 0) {
    return null;
  }

  return (
    <div className={hideHeader ? '' : 'mt-4'}>
      {!hideHeader && (
        <h2 className="py-2 text-sm font-medium text-gray-500">{headerText || t('SearchPage.recentSearches')}</h2>
      )}
      <div className="divide-y divide-gray-100">
        {locations.map((location) => (
          <LocationListItem
            key={location.id}
            title={location.name}
            description={location.description}
            icon={location.icon}
            onClick={() => onLocationSelect(location)}
          />
        ))}
      </div>
    </div>
  );
};
